import PageShell from "@/components/PageShell";
import { Tienda } from "@/components/landing/Tienda";
import { SponsorBanner } from "@/components/Sponsors";

export default function TiendaPage() {
  return (
    <PageShell crumbs={[{ label: "Tienda" }]}>
      <Tienda />
      <SponsorBanner placement="banner_tienda" />
    </PageShell>
  );
}
